import React from "react";
import LegalPage from "../../components/legal-page";

// Pravni tekst je namjerno samo na hrvatskom — mjerodavna je hrvatska verzija.
const Terms = () => {
  return (
    <LegalPage
      title="Uvjeti korištenja"
      updated="Zadnja izmjena: 18. lipnja 2026."
    >
      <h2>1. Pružatelj usluge</h2>
      <p>
        Uslugu pruža <strong>Sensorium d.o.o.</strong>, Ulica Andrije Kačića
        Miošića 41, 10410 Velika Gorica, Hrvatska, OIB:{" "}
        <strong>89225725472</strong>. Kontakt:{" "}
        <a href="mailto:info@nemastruje.com">info@nemastruje.com</a>.
      </p>

      <h2>2. Što je nemastruje.com</h2>
      <p>
        nemastruje.com prikazuje i prosljeđuje <strong>javno objavljene</strong>{" "}
        podatke HEP ODS-a o planiranim prekidima opskrbe električnom energijom te
        podatke komunalnih vodoopskrbnih društava o prekidima opskrbe vodom, i o
        njima vas obavještava za adrese koje ste registrirali.
      </p>
      <p>
        nemastruje.com{" "}
        <strong>
          nije povezan s HEP-om niti s vodoopskrbnim društvima
        </strong>{" "}
        i nije službeni izvor informacija o prekidima. Službene informacije
        objavljuju HEP ODS i nadležna vodoopskrbna društva na svojim stranicama.
      </p>

      <h2>3. Korisnici i prihvat uvjeta</h2>
      <p>
        Usluga je namijenjena fizičkim osobama (potrošačima) za osobnu uporabu.
        Korištenjem usluge potvrđujete da ste pročitali i prihvatili ove uvjete
        te da imate najmanje 16 godina.
      </p>

      <h2>4. Korisnički račun</h2>
      <p>Pri otvaranju i korištenju računa obvezujete se:</p>
      <ul>
        <li>pružiti točne i ažurne podatke,</li>
        <li>čuvati povjerljivost svojih pristupnih podataka,</li>
        <li>bez odgode nas obavijestiti o neovlaštenom korištenju računa.</li>
      </ul>

      <h2>5. Obavijesti su informativne</h2>
      <p>
        Obavijesti koje šaljemo informativne su prirode. Ne jamčimo njihovu
        potpunost, točnost ni pravovremenost — HEP i vodoopskrbna društva mogu
        promijeniti ili otkazati planirane radove bez najave, a objavljeni podaci
        mogu biti nepotpuni ili netočni. Nemojte donositi važne odluke isključivo
        na temelju naših obavijesti.
      </p>

      <h2>6. Usluga se pruža „kakva jest”</h2>
      <p>
        Usluga se pruža „kakva jest” (as is), bez jamstava o dostupnosti ili
        neprekinutom radu. Možemo privremeno ili trajno izmijeniti ili obustaviti
        uslugu.
      </p>

      <h2>7. Besplatno korištenje</h2>
      <p>
        Besplatna razina uključuje praćenje <strong>jedne adrese</strong> uz
        obavijesti <strong>e-poštom</strong>.
      </p>

      <h2>8. Plaćena pretplata, cijene i plaćanje</h2>
      <ul>
        <li>
          Premium i Business razine naplaćuju se godišnje, unaprijed. Sve
          istaknute cijene <strong>uključuju PDV</strong>.
        </li>
        <li>
          Plaćanje karticom obavlja se putem Revoluta (hosted checkout). Nakon
          uspješne uplate šaljemo potvrdu e-poštom; službeni (fiskalizirani)
          račun trenutačno se izdaje ručno i dostavlja zasebno.
        </li>
        <li>
          SMS obavijesti dostupne su uz Premium / Business; za njihovo
          uključivanje potrebno je potvrditi broj mobitela. Dodatne SMS poruke
          mogu se dokupiti u paketima.
        </li>
        <li>
          Pretplatu i automatsku obnovu možete pregledati i mijenjati u odjeljku{" "}
          <strong>„Moj račun”</strong>. Kad je automatska obnova isključena,
          pretplata ostaje aktivna do isteka tekućeg razdoblja i nakon toga se ne
          naplaćuje ponovno.
        </li>
      </ul>

      <h2>9. Pravo potrošača na odustanak</h2>
      <p>
        Kao potrošač imate pravo u roku od 14 dana od sklapanja ugovora (kupnje
        pretplate) jednostrano raskinuti ugovor bez navođenja razloga, pisanim
        zahtjevom na{" "}
        <a href="mailto:info@nemastruje.com">info@nemastruje.com</a>. Ako ste
        izričito zatražili da usluga (obavijesti) započne odmah, a ugovor
        raskinete tijekom tog roka, dužni ste platiti razmjeran dio za do tada
        pruženu uslugu. Pravo na odustanak prestaje kada je usluga u cijelosti
        izvršena uz vašu prethodnu izričitu suglasnost.
      </p>

      <h2>10. Zlouporaba i prestanak</h2>
      <p>
        Zadržavamo pravo suspendirati ili ukinuti račun u slučaju zlouporabe —
        primjerice automatiziranog izvlačenja podataka, ometanja rada sustava,
        neplaćanja ili korištenja protivno ovim uvjetima. Svoj račun možete u
        svakom trenutku obrisati putem odjeljka „Moj račun” ili zahtjevom na{" "}
        <a href="mailto:info@nemastruje.com">info@nemastruje.com</a>.
      </p>

      <h2>11. Ograničenje odgovornosti</h2>
      <p>
        U najvećoj mjeri dopuštenoj zakonom, naša ukupna odgovornost za štetu
        nastalu korištenjem usluge ograničena je do iznosa koji ste platili za
        uslugu u posljednjih 12 mjeseci; za besplatnu razinu odgovornost za štetu
        ne preuzimamo. Navedeno se ne odnosi na štetu prouzročenu namjerno ili
        krajnjom nepažnjom, na odgovornost za štetu zbog smrti ili tjelesne
        ozljede, niti na odgovornost koja se prema prisilnim propisima ne može
        ograničiti ni isključiti.
      </p>

      <h2>12. Obrada osobnih podataka</h2>
      <p>
        Obrada osobnih podataka opisana je u našoj{" "}
        <a href="/privatnost">Politici privatnosti</a>.
      </p>

      <h2>13. Mjerodavno pravo i sporovi</h2>
      <p>
        Na ove uvjete primjenjuje se hrvatsko pravo. Sporove ćemo nastojati
        riješiti mirnim putem; ako to ne uspije, nadležan je stvarno nadležni sud
        prema sjedištu pružatelja usluge.
      </p>

      <h2>14. Izmjene uvjeta</h2>
      <p>
        Uvjete možemo izmijeniti; izmijenjena verzija objavljuje se na ovoj
        stranici s naznačenim datumom zadnje izmjene. Nastavkom korištenja usluge
        nakon objave prihvaćate izmijenjene uvjete.
      </p>

      <h2>15. Kontakt</h2>
      <p>
        Pitanja o ovim uvjetima:{" "}
        <a href="mailto:info@nemastruje.com">info@nemastruje.com</a>.
      </p>
    </LegalPage>
  );
};

export default Terms;
